export default function calcBtnPosition(props) {
  // 设计稿宽度
  const DESIGN_W = props.designW || 2560;
  // 设计稿高度
  const DESIGN_H = props.designH || 1200;
  // 设计稿中按钮的宽度
  const BTN_W = props.btnW;
  // 设计稿中按钮的高度
  const BTN_H = props.btnH;
  // 按钮距离设计稿中心的X轴偏移距离
  const BTN_X_OFFSET = props.btnXOffset;
  // 按钮距离设计稿中心的Y轴偏移距离
  const BTN_Y_OFFSET = props.btnYOffset;
  // 设计稿比例
  const DESIGN_RATIO = DESIGN_W / DESIGN_H;
  // 按钮的宽度和设计稿宽度的比例
  const BTN_W_WITH_DESIGN_W_RETIO = BTN_W / DESIGN_W;
  // 按钮的高度和设计稿高度的比例
  const BTN_H_WITH_DESIGN_H_RETIO = BTN_H / DESIGN_H;

  const { offsetWidth, offsetHeight } = document.documentElement;
  const ratio = offsetWidth / offsetHeight;
  let actualWidth, actualHeight;
  if (ratio >= DESIGN_RATIO) {
    actualWidth = offsetWidth;
    actualHeight = (DESIGN_H * actualWidth) / DESIGN_W;
  } else {
    actualHeight = offsetHeight;
    actualWidth = (DESIGN_W * actualHeight) / DESIGN_H;
  }
  return {
    width: actualWidth * BTN_W_WITH_DESIGN_W_RETIO,
    height: actualHeight * BTN_H_WITH_DESIGN_H_RETIO,
    left: (actualWidth / DESIGN_W) * BTN_X_OFFSET + offsetWidth / 2,
    top: (actualHeight / DESIGN_H) * BTN_Y_OFFSET + offsetHeight / 2
  };
}
